import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import $ from "jquery";
import apiURL from "../../config/environment";
import { isNumberPositiveInt } from "../../utils";
import CheckIcon from "@mui/icons-material/Check";
import {ScheduleSelect} from "./ScheduleSelect";

export const AddIntersectionDialog = ({
  open,
  handleClose,
  existingRows,
  setExistingRows,
    schedules
}) => {
  const [siteId, setSiteId] = useState("");
  const [location, setLocation] = useState("");
  const [detectors, setDetectors] = useState("");
  const [crossings, setCrossings] = useState("");
  const [archived, setArchived] = useState(false);
  const [siteIdError, setSiteIdError] = useState(false);
  const [detectorsError, setDetectorsError] = useState(false);
  const [crossingsError, setCrossingsError] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [scheduleId, setScheduleId] = useState(null);

  useEffect(() => {
    isNumberPositiveInt(siteId, "Site ID", setSiteIdError, true, true);
    isNumberPositiveInt(detectors, "Detectors", setDetectorsError);
    isNumberPositiveInt(crossings, "Ped Buttons", setCrossingsError);
  }, [siteId, detectors, crossings]);

  useEffect(() => {
    if (existingRows.find((row) => row.id == siteId)) {
      setSiteIdError("Site ID already exists");
    }
  }, [siteId])

  const handleDialogClose = () => {
    setSiteId("");
    setLocation("");
    setDetectors("");
    setCrossings("");
    setArchived(false);
    setSiteIdError(false);
    setDetectorsError(false);
    setCrossingsError(false);
    setSaveError(false);
    setScheduleId(null);
    handleClose();
  };

  if (!open) return null;

  const handleSave = () => {
    if (
      !isNumberPositiveInt(siteId, "Site ID", setSiteIdError) ||
      !isNumberPositiveInt(detectors, "Detectors", setDetectorsError) ||
      !isNumberPositiveInt(crossings, "Ped Buttons", setCrossingsError)
    ) {
      return;
    }

    if (existingRows.find((row) => row.id === siteId)) {
      setSiteIdError("Site ID already exists");
      return;
    }
    setSaving(true);
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    $.ajax({
      method: "POST",
      url: apiURL + "admin/site/scats",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      contentType: "application/json",
      data: JSON.stringify({
        id: siteId * 1,
        displayName: location,
        detectors: detectors * 1,
        crossings: crossings / 2,
        archived: archived,
        deviceEffectiveDate: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        scheduleId: scheduleId,
      }),
    })
      .done((data) => {
        setSaving(false);
        setExistingRows([...existingRows, data]);
        handleDialogClose();
      })
      .fail((jqXHR, textStatus, errorThrows) => {
        setSaving(false);
        console.error(
          "Error adding intersection",
          jqXHR,
          textStatus,
          errorThrows
        );
        setSaveError(true);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleDialogClose();
      }}
    >
      <Box sx={{ width: "444px", padding: "16px 24px 24px 24px" }}>
        <DialogTitle sx={{ padding: 0 }} id="form-dialog-title">
          New Intersection
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "16px",
            }}
          >
            {saveError && (
              <Alert severity={"error"}>
                Unable to save. Please try again later.
              </Alert>
            )}
            <TextField
              autoFocus
              id="id"
              type="text"
              fullWidth
              label="Site ID"
              value={siteId}
              onChange={(e) => setSiteId(e.target.value)}
              error={siteIdError}
              helperText={siteIdError}
            />
            <TextField
              id="name"
              type="text"
              fullWidth
              label="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
            <Box display="flex" gap={"16px"}>
              <TextField
                error={detectorsError}
                helperText={detectorsError}
                type="number"
                label="Detectors"
                value={detectors}
                onChange={(e) => setDetectors(e.target.value)}
                fullWidth
              />

              <TextField
                error={crossingsError}
                helperText={crossingsError}
                type="number"
                label="Ped Buttons"
                value={crossings}
                onChange={(e) => setCrossings(e.target.value)}
                fullWidth
                inputProps={{
                  min: 0,
                  step: 2,
                }}
              />
            </Box>
            <ScheduleSelect
                schedules={schedules}
                value={scheduleId}
                onChange={(e) => setScheduleId(e.target.value)}
                />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 0, marginTop: "16px" }}>
          <Button
            disabled={saving}
            onClick={() => {
              handleDialogClose();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={
              !siteId ||
              !location ||
              !detectors ||
              !crossings ||
              siteIdError ||
              detectorsError ||
              crossingsError ||
              saving
            }
            variant={"contained"}
            sx={{
              backgroundColor: "rgba(19, 151, 203, 1)",
              gap: "8px",
              width: "91.75px",
              height: "36.5px",
            }}
          >
            {saving ? (<CircularProgress size={"24.5px"} />) : (
                <>
                  <CheckIcon sx={{ width: "16px", height: "24px" }} />
                  Save
                </>
            )}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
